/* eslint-disable no-nested-ternary */
import {
  Avatar,
  Badge,
  Button,
  Dialog,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextareaAutosize,
} from '@material-ui/core';
import { Close, Forum, Room, Send } from '@material-ui/icons';
import { getInfoAccountByAlias } from '@webapps/business';
import {
  TextField,
  useAuth,
  useQuery,
  useStrophe,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import AvatarStudent from 'components/Avatar/AvatarStudent';

import PropTypes from 'prop-types';
import { createRef, useEffect, useRef, useState } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

const STATUS_MESSAGING = [
  {
    label: 'Absent',
    value: 'away',
  },
  {
    label: 'Disponible',
    value: 'chat',
  },
  {
    label: 'Occupé',
    value: 'dnd',
  },
  {
    label: 'Déconnecté',
    value: 'xa',
  },
];

const MailboxBusiness = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { email, userAlias } = useAuth();
  const jabId = `${userAlias}@linkpick.fr`;

  const {
    archive,
    connect,
    connectStrophe,
    contacts,
    disconnect,
    endIQ,
    getAllMessageWithQuery,
    getRoster,
    jabberUser,
    messagesReceived,
    sendMessage,
    setArchive,
    setConnect,
    setPresence,
  } = useStrophe();

  const [recipient, setRecipient] = useState('');
  const [messageText, setMessageText] = useState('');
  const [userSelect, setUserSelect] = useState('');
  const messagesEndRef = useRef(null);
  const [ourContact, setOurContact] = useState([]);
  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };
  const getRecipient = (e) => {
    if (e.target.value) {
      setRecipient(e.target.value);
    }
  };

  const getMessageText = (e) => {
    setMessageText(e.target.value);
  };

  const setStatusMessaging = (event) => {
    setPresence(event.target.value);
  };

  const sendMessageToRecipient = () => {
    setMessageText(' ');
    sendMessage({ to: userSelect, msg: messageText });
    const msgData = {
      id: new Date(),
      with: '',
      timestamp: new Date(),
      timestamp_orig: new Date().toISOString(),
      from: jabId,
      to: '',
      type: 'chat',
      body: messageText,
      message: messageText,
    };
    setArchive((current) => [...current, msgData]);
  };

  useEffect(() => {
    if (connect) {
      getRoster({ from: jabId });
    }
  }, [connect]);

  // Retrieve & update contact list according to changes
  // Hook triggered when contacts are updated
  useEffect(() => {
    if (contacts.length > 0 && connect) {
      setOurContact(contacts);
      setUserSelect(contacts[0]);
      //console.log(contacts);
    }
  }, [contacts, connect]);

  // Select first user in contact list & get dialog messages for this contact
  // Hook triggered when contact list is fully available
  useEffect(() => {
    if (contacts.length === ourContact.length && connect) {
      getAllMessageWithQuery({ withUser: ourContact[0] });
      // console.log('Messages récupérés')
    }
  }, [ourContact, connect]);

  useEffect(() => {
    scrollToBottom();
  }, [archive, messagesReceived]);

  const handleClick = (item) => {
    getAllMessageWithQuery({ withUser: item });
    setUserSelect(item);
    setOpen(true);
    scrollToBottom();
  };

  useEffect(() => {
    if (endIQ) {
      scrollToBottom();
    }
  }, [endIQ]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const filtreTexte = (arr, requete) =>
    arr.filter((el) => el.toLowerCase().indexOf(requete.toLowerCase()) !== -1);

  const searchContact = (e) => {
    if (e.target.value) {
      setOurContact(filtreTexte(contacts, e.target.value));
    } else if (e.target.value === '') {
      setOurContact(contacts);
    }
  };

  const EnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      sendMessageToRecipient();
    }
  };

  return (
    <div className={classes.container}>
      {connect && (
        <Grid container className={classes.boxContain}>
          <Grid item xs={12} md={5} className={css({ height: '100%' })}>
            <div className={classes.leftSide}>
              <div className={css({ margin: spacing(2) })}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  style={{ backgroundColor: '#F3F7FF' }}
                  label="Qui souhaitez-vous contacter ?"
                  onChange={(e) => searchContact(e)}
                  size="small"
                  variant="filled"
                />
              </div>
              <div>
                {contacts?.map((item, index) => (
                  <InfoContact
                    key={index}
                    handleClick={handleClick}
                    item={item.split('@')[0]}
                    messagesReceived={messagesReceived}
                    userSelect={userSelect}
                  />
                ))}
              </div>
            </div>
          </Grid>
          {/* <Divider orientation="vertical" /> */}
          <Grid item xs={12} md={7} className={css({ height: '100%' })}>
            <div className={classes.rightSide}>
              <div className={classes.contentMessage}>
                <Grid
                  className={css({ borderBottom: '1px solid #C0D9FF' })}
                  container
                  spacing={0}
                >
                  <Grid item xs={12}>
                    <HeaderContact item={userSelect.split('@')[0]} />
                  </Grid>
                </Grid>
                <div className={classes.messages}>
                  {endIQ &&
                    archive?.map(
                      (
                        { from, id, message, timestamp, timestamp_orig: date },
                        index
                      ) => (
                        <>
                          <div key={'message' + index}>
                            {index === 0 ? (
                              <div className={classes.displayDate}>
                                <div
                                  className={css({
                                    textTransform: 'uppercase',
                                    background: 'white',
                                    zIndex: 100,
                                    padding: spacing(0, 2),
                                    '@media only screen and (max-width:1920px)': { fontSize: '13.5000px' },
                                    '@media only screen and (max-width:1600px)': { fontSize: '10px' },

                                    fontWeight: 400,
                                  })}
                                >
                                  <FormattedDate
                                    day="numeric"
                                    month="long"
                                    value={date}
                                    year="numeric"
                                  />
                                </div>
                              </div>
                            ) : new Date(date?.split('T')[0]) >
                              new Date(
                                archive[index - 1].timestamp_orig.split('T')[0]
                              ) ? (
                              <div className={classes.displayDate}>
                                <div
                                  className={css({
                                    textTransform: 'uppercase',
                                    background: 'white',
                                    zIndex: 100,
                                    padding: spacing(0, 2),
                                    '@media only screen and (max-width:1920px)': { fontSize: '13.5000px' },
                                    '@media only screen and (max-width:1600px)': { fontSize: '10px' },

                                    fontWeight: 400,
                                  })}
                                >
                                  <FormattedDate
                                    day="numeric"
                                    month="numeric"
                                    value={new Date(date?.split('T')[0])}
                                    year="numeric"
                                  />
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <div
                            key={id}
                            className={css({
                              padding: spacing(1),
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems:
                                from === jabId ? 'flex-end' : 'flex-start',
                            })}
                          >
                            <div
                              className={css({
                                padding: spacing(1.5),
                                display: 'flex',
                                maxWidth: '60%',
                                // width: 'fit-content',
                                flexDirection: 'row',
                                background:
                                  from === jabId ? '#67A1FF' : '#F3F7FF',
                                borderRadius:
                                  from === jabId
                                    ? '10px 10px 0px 10px'
                                    : '10px 10px 10px 0',
                              })}
                            >
                              <div className={css({ width: '100%' })}>
                                <div>
                                  <TextareaAutosize
                                    className={css({
                                      width: '100%',
                                      resize: 'none',
                                      background:
                                        from === jabId ? '#67A1FF' : '#F3F7FF',
                                      border: 'none',
                                      '@media only screen and (max-width:1920px)':
                                        { fontSize: '13.500px' },
                                      '@media only screen and (max-width:1600px)':
                                        { fontSize: '13.5000px' },
                                      fontFamily: 'Roboto',
                                      color:
                                        from === jabId ? 'white' : '#152652',
                                      lineHeight: 1.5,
                                      marginRight: spacing(1),
                                    })}
                                    disabled
                                    name="description"
                                    value={message}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className={css({
                                color: '#5D75A8',
                                '@media only screen and (max-width:1920px)': { fontSize: '14px' },
                                '@media only screen and (max-width:1600px)': { fontSize: '10px' },
                                fontFamily: 'Roboto',
                                marginTop: spacing(1),
                              })}
                            >
                              <FormattedTime value={new Date(timestamp)} />
                            </div>
                          </div>
                        </>
                      )
                    )}
                  <div ref={messagesEndRef} />
                </div>
                <Divider />
              </div>
              <div className={classes.sendMessage}>
                <div
                  className={css({
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: spacing(2),
                  })}
                >
                  <Button
                    className={classes.sendButton}
                    color="primary"
                    onClick={sendMessageToRecipient}
                    size="small"
                    variant="contained"
                  >
                    <Send
                      style={{
                        fontSize: '15.0px',
                        color: 'white',
                        transform: 'rotate(180deg)',
                      }}
                    />
                  </Button>
                  <textarea
                    onKeyDown={EnterPress}
                    className={css({
                      width: '87%',
                      height: '52px',
                      background: '#F3F7FF',
                      border: '1px solid #C0D9FF',
                      fontFamily: 'Roboto',
                      color: '#152652',
                      padding: spacing(2),
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '13.500px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '13.5000px',
                      },
                      borderRadius: 6,
                      resize: 'none',
                      '&::placeholder': { color: '#5D75A8' },
                    })}
                    onChange={(e) => getMessageText(e)}
                    placeholder="Ecrire un message"
                    value={messageText}
                  />
                </div>
              </div>
            </div>
          </Grid>

          {/* MODAL FOR MOBILE */}

          <Dialog
            fullScreen
            className={classes.detailsModal}
            onClose={closeModal}
            open={open}
          >
            <Grid item xs={12} md={6} className={classes.rightSideMobile}>
              <div className={classes.contentMessage}>
                <Grid
                  className={css({ borderBottom: '1px solid #C0D9FF' })}
                  container
                  spacing={0}
                >
                  <Grid item xs={12}>
                    <HeaderContact
                      item={userSelect.split('@')[0]}
                      closeModal={closeModal}
                    />
                  </Grid>
                </Grid>
                <div className={classes.messages}>
                  {endIQ &&
                    archive?.map(
                      (
                        { from, id, message, timestamp, timestamp_orig: date },
                        index
                      ) => (
                        <>
                          <div key={'mobile' + index}>
                            {index === 0 ? (
                              <div className={classes.displayDate}>
                                <div
                                  className={css({
                                    textTransform: 'uppercase',
                                    background: 'white',
                                    zIndex: 100,
                                    padding: spacing(0, 2),
                                    '@media only screen and (max-width:1920px)': { fontSize: '13.5000px' },
                                    '@media only screen and (max-width:1600px)': { fontSize: '10px' },
                                    fontWeight: 400,
                                  })}
                                >
                                  <FormattedDate
                                    day="numeric"
                                    month="long"
                                    value={date}
                                    year="numeric"
                                  />
                                </div>
                              </div>
                            ) : new Date(date?.split('T')[0]) >
                              new Date(
                                archive[index - 1].timestamp_orig.split('T')[0]
                              ) ? (
                              <div className={classes.displayDate}>
                                <div
                                  className={css({
                                    textTransform: 'uppercase',
                                    background: 'white',
                                    zIndex: 100,
                                    padding: spacing(0, 2),
                                    '@media only screen and (max-width:1920px)': { fontSize: '13.5000px' },
                                    '@media only screen and (max-width:1600px)': { fontSize: '10px' },
                                    fontWeight: 400,
                                  })}
                                >
                                  <FormattedDate
                                    day="numeric"
                                    month="numeric"
                                    value={new Date(date?.split('T')[0])}
                                    year="numeric"
                                  />
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <div
                            key={id}
                            className={css({
                              padding: spacing(1),
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems:
                                from === jabId ? 'flex-end' : 'flex-start',
                            })}
                          >
                            <div
                              className={css({
                                padding: spacing(1.5),
                                display: 'flex',
                                maxWidth: '60%',
                                // width: 'fit-content',
                                flexDirection: 'row',
                                background:
                                  from === jabId ? '#67A1FF' : '#F3F7FF',
                                borderRadius:
                                  from === jabId
                                    ? '10px 10px 0px 10px'
                                    : '10px 10px 10px 0',
                              })}
                            >
                              <div className={css({ width: '100%' })}>
                                <div>
                                  <TextareaAutosize
                                    className={css({
                                      width: '100%',
                                      resize: 'none',
                                      background:
                                        from === jabId ? '#67A1FF' : '#F3F7FF',
                                      border: 'none',
                                      '@media only screen and (max-width:1920px)':
                                        { fontSize: '13.500px' },
                                      '@media only screen and (max-width:1600px)':
                                        { fontSize: '13.5000px' },
                                      fontFamily: 'Roboto',
                                      color:
                                        from === jabId ? 'white' : '#152652',
                                      lineHeight: 1.5,
                                      marginRight: spacing(1),
                                    })}
                                    disabled
                                    name="description"
                                    value={message}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className={css({
                                color: '#5D75A8',
                                '@media only screen and (max-width:1920px)': { fontSize: '14px' },
                                '@media only screen and (max-width:1600px)': { fontSize: '10px' },
                                fontFamily: 'Roboto',
                                marginTop: spacing(1),
                              })}
                            >
                              <FormattedTime value={new Date(timestamp)} />
                            </div>
                          </div>
                        </>
                      )
                    )}
                  <div ref={messagesEndRef} />
                </div>
                <Divider />
              </div>
              <div className={classes.sendMessage}>
                <div
                  className={css({
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: spacing(2.5),
                    padding: spacing(2),
                  })}
                >
                  <Button
                    className={classes.sendButton}
                    onClick={sendMessageToRecipient}
                    size="small"
                    variant="contained"
                  >
                    <Send
                      style={{
                        fontSize: '15.0px',
                        color: 'white',
                        transform: 'rotate(180deg)',
                      }}
                    />
                  </Button>
                  <textarea
                    className={css({
                      width: '87%',
                      height: '52px',
                      background: '#F3F7FF',
                      border: '1px solid #C0D9FF',
                      fontFamily: 'Roboto',
                      color: '#152652',
                      padding: '15px',
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '13.500px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '13.5000px',
                      },
                      borderRadius: 6,
                      resize: 'none',
                      '&::placeholder': { color: '#5D75A8' },
                    })}
                    onChange={(e) => getMessageText(e)}
                    placeholder="Ecrire un message"
                    value={messageText}
                  />
                </div>
              </div>
            </Grid>
          </Dialog>
        </Grid>
      )}
    </div>
  );
};

const InfoContact = ({ handleClick, item, userSelect, messagesReceived }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const width = window.innerWidth;

  const { data: infos = [] } = useQuery(getInfoAccountByAlias, {
    key: ['profilInfo', item],
    variables: { alias: item },
  });

  let messagesFromUser = messagesReceived?.filter((el) => el.from === item);

  return (
    <>
      <Grid
        key={item}
        className={css({
          // background: item.id === info.id && backgroundItemActive,
          padding: spacing(2),
          display: 'flex',
          cursor: 'pointer',
          // borderLeft: `15px solid #E8E8E8`,
          borderLeft:
            item === userSelect?.split('@')[0]
              ? `15px solid #0060F9`
              : `15px solid #E8E8E8`,
        })}
        container
        item
        onClick={() => handleClick(`${item}@linkpick.fr`)}
        spacing={0}
        xs={12}
      >
        {width > 1024 ? (
          <div>
            <AvatarStudent applicant={infos} height={80} width={80} />
          </div>
        ) : (
          <div>
            <AvatarStudent applicant={infos} height={60} width={60} />
          </div>
        )}
        <div
          className={css({
            marginLeft: spacing(2),
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          })}
        >
          <div
            style={{ marginBottom: spacing(1) }}
            className={global.title}
          >
            {infos?.childClass === 'IndividualAccount'
              ? infos?.fullName
              : infos?.name}
          </div>
          <div className={cx(global.infoText, classes.address)}>
            {infos?.address?.cityCode && (
              <>
                <Room className={global.infoIcon} />
                <div>
                  {infos?.address?.cityCode} {infos?.address?.city}
                </div>
              </>
            )}
          </div>
          {messagesFromUser?.length ? (
            <Badge
              badgeContent={messagesFromUser.length}
              color="secondary"
              className={classes.badge}
            >
              <IconButton className={classes.btn}></IconButton>
            </Badge>
          ) : null}
        </div>
      </Grid>
      <Divider />
    </>
  );
};

InfoContact.propTypes = {
  handleClick: PropTypes.func,
  item: PropTypes.string,
  messagesReceived: PropTypes.string,
  userSelect: PropTypes.string,
};

const HeaderContact = ({ item, closeModal }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const width = window.innerWidth;

  const { data: infos = [] } = useQuery(getInfoAccountByAlias, {
    key: ['profilInfo', item],
    variables: { alias: item },
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div
        className={css({
          padding: spacing(1.5),
          display: 'flex',
          alignItems: 'center',
        })}
      >
        {width > 1024 ? (
          <div>
            <AvatarStudent applicant={infos} height={80} width={80} />
          </div>
        ) : (
          <div>
            <AvatarStudent applicant={infos} height={60} width={60} />
          </div>
        )}
        <div
          className={css({
            padding: spacing(1),
          })}
        >
          <div
            style={{ marginBottom: spacing(1) }}
            className={global.title}
          >
            {infos?.childClass === 'IndividualAccount'
              ? infos?.fullName
              : infos?.name}
          </div>
          <div className={cx(global.infoText, classes.address)}>
            {infos?.address?.cityCode && (
              <>
                <Room className={global.infoIcon} />
                <div>
                  {infos?.address?.cityCode} {infos?.address?.city}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Button
        onClick={closeModal}
        className={classes.mobileOnly}
        style={{
          position: 'absolute',
          color: '#000',
          right: 0,
          top: 0,
          border: 'none',
          '&.hover': { border: 'none' },
        }}
      >
        <Close />
      </Button>
    </div>
  );
};

HeaderContact.propTypes = {
  item: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
        padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    lineHeight: '110%',
    height: 'calc(100vh - 75px)',
    '@media only screen and (max-width:768px)': {
      padding: '20px',
    },
  },
  contain: {
    borderRadius: 10,
    padding: spacing(2),
    marginTop: spacing(5),
  },
  boxContain: {
    height: '100%',
    '@media only screen and (max-width:768px)': {
      marginTop: spacing(3),
    },
  },
  leftSide: {
    overflowY: 'auto',
    marginRight: '8px',
    paddingTop: spacing(0.5),
    background: 'white',
    height: '100%',
    borderRadius: 10,
  },
  rightSide: {
    background: 'white',
    marginLeft: '8px',
    height: '100%',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width:1023px)': { display: 'none' },
  },
  rightSideMobile: {
    overflowY: 'auto',
    background: 'white',
    height: '100%',
    maxHeight: 'calc(100% - 90px)',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (min-width:1024px)': { display: 'none' },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.3),
  },
  displayDate: {
    display: 'flex',
    justifyContent: 'center',
    margin: spacing(1, 0),
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: 1,
      width: '100%',
      background: '#C0D9FF',
    },
  },
  contentMessage: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  messages: {
    overflowY: 'auto',
    flex: '1 1 auto',
  },
  sendMessage: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  detailsModal: {
    display: 'flex',
    alignItems: 'flex-end',
    '@media only screen and (min-width:1023px)': { display: 'none' },
  },
  mobileOnly: {
    '@media only screen and (min-width:1023px)': { display: 'none' },
  },
  sendButton: {
    borderRadius: '10.0000px',
    padding: spacing(1.5, '4%'),
    color: 'white',
    backgroundColor: '#0060F9',
  },
});

export default MailboxBusiness;
